const translations = {
    kml: 'KML'
};

export default translations;
